import { render, staticRenderFns } from "./class_teacher.vue?vue&type=template&id=5efff106&scoped=true"
import script from "./class_teacher.vue?vue&type=script&lang=ts"
export * from "./class_teacher.vue?vue&type=script&lang=ts"
import style0 from "./class_teacher.vue?vue&type=style&index=0&id=5efff106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efff106",
  null
  
)

export default component.exports